"use strict";
export var SlippageTolerance = /* @__PURE__ */ ((SlippageTolerance2) => {
  SlippageTolerance2["Auto"] = "auto";
  return SlippageTolerance2;
})(SlippageTolerance || {});
